import { withInstall } from '@code-monkey-ui/utils'

import Pagination from './src/pagination'

export const ElPagination = withInstall(Pagination)
export default ElPagination

export * from './src/pagination'
export * from './src/constants'
